/**
 * Vis.js Timeline Library Loader Composable
 * Handles dynamic loading of the Vis.js Timeline library
 */

import { onMounted, ref } from 'vue';

/**
 * Composable to load the Vis.js Timeline library dynamically
 * @returns Object with isLoaded state and load function
 */
export const useVisLibraryLoader = () => {
    const isLoaded = ref(false);

    /**
     * Loads the Vis.js Timeline library if not already loaded
     */
    const loadVisLibrary = (): void => {
        if (!window.vis) {
            const script = document.createElement('script');
            script.src = new URL(
                '@agyletime/agyle-vis-timeline/dist/vis-timeline-graph2d.min.js',
                import.meta.url
            ).href;
            script.onload = () => {
                isLoaded.value = true;
            };
            script.onerror = (_error) => {
                
            };
            document.head.appendChild(script);
        } else {
            isLoaded.value = true;
        }
    };

    /**
     * Checks if the Vis.js library is loaded
     * @returns True if library is loaded, false otherwise
     */
    const isLibraryLoaded = (): boolean => {
        return !!window.vis;
    };

    onMounted(() => {
        loadVisLibrary();
    });

    return {
        loadVisLibrary,
        isLibraryLoaded,
        isLoaded
    };
};
